import { useEffect, useState } from 'react'
import { getInstallationsWithApproachingInstallationStatementDeadline } from '../api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { Installation, StatementStatusEnum } from '../models'

/**
 * hook that return installations whose installation statement is incomplete and whose deadline is approaching or over.
 */
export const useInstallationStatementDeadline = (): Installation[] => {
  const authFetch = useAuthFetchWithResponse()
  const [installationsWithStatementDeadlineApproaching, setInstallationsWithStatementDeadlineApproaching] = useState<Installation[]>([])

  useEffect(() => {
    const fetchInstallationsWithApproachingInstallationStatementDeadline = async (): Promise<void> => {
      /* fetch installations whose installation statement deadline is approaching or over */
      const { value } = await getInstallationsWithApproachingInstallationStatementDeadline(authFetch)

      if (!value || value.length === 0) {
        setInstallationsWithStatementDeadlineApproaching([])
        return
      }

      /* filter installations whose installation statement is incomplete */
      const incompleteInstallations = value.filter(installation => installation.statementStatus === StatementStatusEnum.Incomplete)
      setInstallationsWithStatementDeadlineApproaching(incompleteInstallations)
    }

    fetchInstallationsWithApproachingInstallationStatementDeadline()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return installationsWithStatementDeadlineApproaching
}
